/* eslint-disable */
import React, { useEffect, useState, useContext }from 'react';
import Card from '../../components/card.component';
import {
  Row,
  Col
} from 'react-bootstrap';
import { useForm } from "react-hook-form";
import sucursalFunction from './sucursal.functions';
import table from './sucursal.table';
import notification from '../../components/notification.component';
import DataTable from 'react-data-table-component';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faShieldAlt,
} from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { ConfigContextUtils } from '../../context/contextUtils.context';


const ConfigSucursal = () => {

  const { setPreloader } = useContext(ConfigContextUtils);
  const { uuid } = useParams();
  const [modo, setModo] = useState('I');
  const [idMod, setModId] = useState(0);
  const [listado, setListado] = useState([]);
  const [sucursal, setSucursal] = useState(null);
  const { register, handleSubmit, reset, errors, setValue } = useForm();
  const onSubmit = data => {

   setPreloader(true);
   { modo === 'I' ? 
      sucursalFunction.usuario({...data, sucursal_id: sucursal.id}).then((response) => {
        if (response.data.registro_usuario) {
          notification.success();
          reset();
          listadoApi();
        } else {
          notification.warning('Ocurrio un error intentelo nuevamente');
        }
        setPreloader(false);
      })
      : 
      sucursalFunction.userUpdate({...data, user_id: idMod}).then((response) => {
        if (response.data.modifica_usuario) {
          notification.success();
          reset();
          listadoApi();
        } else {
          notification.warning('Ocurrio un error intentelo nuevamente');
        }
        setPreloader(false);
      })
    }
  }

  const listadoApi = () => {
    if (sucursal !== null) {
      sucursalFunction.listadoUsuarios({ id: sucursal.id }).then((response) => {
        setListado(response);
      })
    }
  }

  const sucursalInfo = () => {
    sucursalFunction.filtro({ uuid }).then((response) => {
      setSucursal(response.data);
    })
  }

  const selectionClient = (row) => {
    reset({
      ...row,
      password_x: row.password,
    });
    setModId(row.id);
    setModo('M');
  }

  const cancelOperation = () => {
    reset({});
    setModo('I');
  }

  useEffect(() => {
    sucursalInfo();
  },[])

  useEffect(() => {
    listadoApi();
  },[sucursal])

  const setPassword = () => {
    const pwd = sucursalFunction.password();
    setValue("password_x", `${pwd}`,  { shouldValidate: true });
    setValue("password", `${pwd}`,  { shouldValidate: true });
  }

  const setToggle = (valor, id) => {
    sucursalFunction.activar({ active: valor ? 0 : 1, id: id }).then((response) => {
      if (response.activar_usuario) {
        setListado(sucursalFunction.changeStatus(listado, id));
      }
    })
  }

  return (
  <>
  <Row>
    <Col lg={6}>
        <Card>
          <Row>
            <Col>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="grupo-input">
                  <small>Registrada</small>
                  <div>{sucursal !== null ? moment(sucursal.createdAt).format('DD/MM/YYYY H:m:s') : null}</div>
                </div>
                <div className="grupo-input">
                  <small>Nombre sucursal</small>
                  <div>{sucursal !== null ? sucursal.description : null}</div>
                </div>
                <div className="grupo-input">
                  <small>Dirección</small>
                  <div>{sucursal !== null ? sucursal.address : null}</div>
                </div>
              </form>
            </Col>
          </Row>
        </Card>
      </Col>
      <Col lg={6}>
        <Card>
          <Row>
            <Col>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="grupo-input">
                  <small>Nombre y Apellido</small>
                  <input type="text" className={`form-control input-border ${errors.nombre_usuario && "is-invalid"}`} name="nombre_usuario" ref={register({ required: true })} />
                </div>
                <div className="grupo-input">
                  <small>Usuario</small>
                  <input type="text" className={`form-control input-border ${errors.description && "is-invalid"}`} name="username" ref={register({ required: true })} />
                </div>
                <div className="grupo-input">
                  <small>Contraseña</small>
                  <div className="d-flex">
                   <input disabled type="text" className={`form-control input-border ${errors.address && "is-invalid"}`} name="password_x" ref={register({ required: true })} />
                   <button type="button" onClick={setPassword} className="btnx btnx-warn icon-table">
                      <FontAwesomeIcon icon={faShieldAlt} />
                   </button>
                  </div>
                </div>
                <div className="grupo-input">
                  <small>Tipo</small>
                  <select className={`form-control input-border ${errors.tipo_id && "is-invalid"}`} name="tipo_id" ref={register({ required: true, validate: (value) => value !== 'null'})}>
                    <option value="null">Seleccione...</option>
                    <option value="1">ADMINISTRADOR</option>
                    <option value="2">GESTOR DE GUIAS</option>
                  </select>
                </div>
                <div className="grupo-input mt-2">
                  <input type="hidden" name="password" ref={register({ required: true })} />
                  <button type="submit" className="btnx btnx-warn">
                   { modo === 'I' ? 'Registrar' : 'Modificar' } 
                  </button> 
                  {' '}<button onClick={cancelOperation} type="button" className="btnx btnx-warn">Cancelar</button>
                </div>
              </form>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
    <Row className="mt-3">
    <Col lg={12}>
     <Card>
      <Row>
        <Col>
           <DataTable
            title="Usuarios"
            customStyles={table.customStyles}
            columns={table.columnsUsuarios(selectionClient, () => console.log('a'), setToggle)}
            data={listado}
            dense={true}
            pagination={true}
        /> 
        </Col>
       </Row>
      </Card>
     </Col>
    </Row>
    </>
  )
}

export default ConfigSucursal;